"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var merge_1 = require("./merge");
var shallowMerge_1 = require("./shallowMerge");
exports.mergeDeep = mergeDeepFactory(merge_1.merge);
exports.shallowMergeDeep = mergeDeepFactory(shallowMerge_1.shallowMerge);
function mergeDeepFactory(mrg) {
    var mrgDeep;
    mrgDeep = function (a, b) {
        var r = a;
        for (var p in b) {
            if (b.hasOwnProperty(p)) {
                var v = isObject(b, p) ? mergeProperty(a, b, p, mrg, mrgDeep) : b[p];
                r = mrg(r, (_a = {}, _a[p] = v, _a));
            }
        }
        return r;
        var _a;
    };
    return mrgDeep;
}
function mergeProperty(a, b, p, mrg, mrgDeep) {
    if (a.hasOwnProperty(p)) {
        return mrgDeep(a[p], b[p], mrg);
    }
    return b[p];
}
function isObject(b, p) {
    return (null !== b[p] && typeof b[p] === "object" && !Array.isArray(b[p]));
}
